import { CriteriaResult } from '@frontend/data-access';
import useTranslation from 'next-translate/useTranslation';

export interface ApplicationEvaluationResultTagProps {
  criteriaResults?: CriteriaResult[];
}

export function ApplicationEvaluationResultTag({
  criteriaResults = [],
}: ApplicationEvaluationResultTagProps) {
  const { t } = useTranslation('common');

  const results =
    criteriaResults.filter(
      (result) =>
        result.criteria.type === 'CHALLENGE_EXPERT' && result.status === 'DONE'
    ) || [];
  const average =
    results.reduce((prev, curr) => prev + curr?.scale, 0) / results.length;

  const score = isNaN(average) ? '-' : average.toFixed(1);
  const expertCount = results.reduce(
    (prev, curr) => prev.add(curr?.createdBy?.id),
    new Set<number>([])
  );

  if (criteriaResults) {
    return (
      <div className="space-x-2">
        <span className="bg-red-100 text-red-600 px-2 py-1 rounded-full min-w-6 h-6 text-center">
          {score}
        </span>
        {expertCount.size > 0 && (
          <span>{t('by_experts', { count: expertCount.size })}</span>
        )}
      </div>
    );
  } else return null;
}

export default ApplicationEvaluationResultTag;
